import { useParams } from 'react-router-dom';
import React from 'react';
import useSWR from 'swr';
import { Box, Button } from 'rebass';
import Wrapper from 'stories/tell-a-story/Wrapper';
import ResponsiveReactPlayer from 'story-media/medium-types/ResponsiveReactPlayer';

const FinalVideoPreview = () => {
    const { mediaId } = useParams();
    const { data } = useSWR(mediaId ? `v3/public/watch_me_grow_videos/${mediaId}` : null)
    const videoData = data?.data?.data
    const included = data?.data?.included

    const videoDetails = videoData?.relationships?.['video'].data;

    const video = included && included.find(i => i.id === videoDetails?.id && i.type === videoDetails?.type);

    //  <Wrapper p={2} justifyContent="center" alignItems="center">
    return <Box sx={{ position: 'fixed', top: 0, height: '100vh', width: '100vw' }}>
        <ResponsiveReactPlayer
            url={video?.attributes?.['hls-portrait']}
            preload={true}
            playerWrapper={{ height: 'inherit' }}
            style={{
                borderRadius: '10px',
                // transform: 'rotate(90deg)',
                transformOrigin: 'center',
            }}
        />
    </Box>
    {/* <a
            href={`${video?.attributes?.['hls-portrait']}?download=true`}
            download
        >
            <Button m="auto" sx={{ borderRadius: '23px', padding: '10px 20px', height: '44px' }} >
                Download Video
            </Button>
        </a> */}
    // </Wrapper>

    return null
};

export default FinalVideoPreview;
